module.exports = __webpack_public_path__ + "img/de_03.9a001a7d.png";